<template>
  <div>
    <a-table ref="table" size="small" :pagination="false" row-key="id" :columns="columns" :data-source="dataSource">
      <span slot="creator" slot-scope="text, record"> {{ record.creator.nickname }} </span>
      <span slot="status" slot-scope="text, record">
        <a-badge :status="releaseDeployStatus[record.status].status" :text="releaseDeployStatus[record.status].label" />
      </span>
      <span slot="params" slot-scope="text, record">
        {{ record.build_params }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="onShowConsole(record)"> 查看日志 </a>
      </span>
    </a-table>
    <service-deploy-console :record-id="recordId" :visible="visible" @close="onClose" />
  </div>
</template>
<script>
import { releaseDeployStatus, releaseEnvs } from '@/utils/dictionary';
import ServiceDeployConsole from '@/pages/project/workflow/release/components/ServiceDeployConsole';

const columns = [
  {
    title: 'ID',
    width: 80,
    dataIndex: 'id'
  },
  {
    title: '编号',
    width: 80,
    dataIndex: 'build_number'
  },
  {
    title: '环境',
    align: 'environment',
    width: 80,
    dataIndex: 'environment',
    customRender: (_text, _row) => {
      return releaseEnvs[_row.environment].label;
    }
  },
  {
    title: '构建参数',
    dataIndex: 'build_params',
    ellipsis: true
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 100,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '操作人',
    width: 80,
    dataIndex: 'creator',
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '操作时间',
    width: 164,
    dataIndex: 'created_time'
  },
  {
    title: '操作',
    width: 80,
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  components: { ServiceDeployConsole },
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      releaseEnvs,
      releaseDeployStatus,
      columns,
      recordId: null,
      visible: false
    };
  },
  methods: {
    onShowConsole(record) {
      this.recordId = record.id;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
      this.recordId = null;
    }
  }
};
</script>
